<template>
<div class="body1">
 <el-form  :model="form1"  status-icon :rules="rules" ref="form1" label-width="100px">
   <div style="font-size: 35px;font-weight: bold;text-align: center">评价申请</div>
  <el-form-item label="企业名称" prop="eName">
    <el-input v-model="form1.eName"></el-input>
  </el-form-item>
   <el-form-item label="统一社会信用代码" prop="eCode">
    <el-input v-model="form1.eCode"></el-input>
  </el-form-item>
   <el-form-item label="企业联系人" prop="contacts">
    <el-input v-model="form1.contacts"></el-input>
  </el-form-item>
   <el-form-item label="法定代表人" prop="jperson">
    <el-input v-model="form1.jperson"></el-input>
  </el-form-item>
   <el-form-item label="手机" prop="tel">
    <el-input v-model="form1.tel"></el-input>
  </el-form-item>
   <el-form-item label="企业地址" prop="eAddr">
    <el-input v-model="form1.eAddr"></el-input>
  </el-form-item>

   <el-form-item label="企业名称（英文）" prop="enterprise">
    <el-input v-model="form1.enterprise"></el-input>
  </el-form-item>
   <el-form-item label="企业网址" prop="website">
    <el-input v-model="form1.website"></el-input>
  </el-form-item>
   <el-form-item label="企业联系邮箱" prop="email">
    <el-input v-model="form1.email"></el-input>
  </el-form-item>
   <el-form-item label="企业介绍" prop="introduce">
    <el-input type="textarea"  rows="10" cols="20" v-model="form1.introduce"></el-input>
  </el-form-item>
   <el-form-item label="成立时间" prop="foundtime">
    <el-input v-model="form1.foundtime"></el-input>
  </el-form-item>
   <el-form-item label="目前员工数" prop="staff">
    <el-input v-model="form1.staff"></el-input>
  </el-form-item>
   <el-form-item label="所属行业" prop="industry">
    <el-input v-model="form1.industry"></el-input>
  </el-form-item>
   <el-form-item label="企业优势" prop="advantage">
    <el-input v-model="form1.advantage"></el-input>
  </el-form-item>
   <el-form-item label="企业所有制" prop="classify">
    <el-input v-model="form1.classify"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary"  @click="checkForm('form1')"  @keyup.enter.native="checkForm('form1')">提交申请</el-button>
    <router-link to='/enterpriselist' ><el-button type="primary" >放弃申请</el-button></router-link>
  </el-form-item>
</el-form>
   </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl, dataPost } from '@/api/index'
export default {
  name: 'enterevaluation',
  data () {
    var eName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入企业名称'))
      } else {
        callback()
      }
    }
    var eCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('统一社会信用代码不能为空'))
      } else {
        const reg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的统一社会信用代码'))
        }
      }
    }
    var contacts = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系人'))
      } else {
        callback()
      }
    }
    var eAddr = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入注册地址'))
      } else {
        callback()
      }
    }
    var jperson = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入法定代表人'))
      } else {
        callback()
      }
    }
    var email = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      } else {
        const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的邮箱'))
        }
      }
    }
    var enterprise = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入企业英文名'))
      } else {
        callback()
      }
    }
    var website = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('网址不能为空'))
      } else {
        // eslint-disable-next-line no-useless-escape
        const reg = /^(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的网址'))
        }
      }
    }
    var introduce = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入企业介绍'))
      } else {
        callback()
      }
    }
    var foundtime = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入成立时间'))
      } else {
        callback()
      }
    }
    var staff = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入目前员工数'))
      } else {
        callback()
      }
    }
    var industry = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入所属行业'))
      } else {
        callback()
      }
    }
    var advantage = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入企业优势'))
      } else {
        callback()
      }
    }
    var Classify = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入企业所有制'))
      } else {
        callback()
      }
    }
    var tel = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      } else {
        const reg = /^1[3456789]\d{9}$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号码'))
        }
      }
    }
    return {
      form1: {
        eName: '',
        eCode: '',
        jperson: '',
        tel: '',
        createTime: '',
        updateTime: '',
        contacts: '',
        indSubname: '',
        provName: '',
        cityName: '',
        distName: '',
        eAddr: '',

        enterprise: '',
        website: '',
        email: '',
        introduce: '',
        foundtime: '',
        staff: '',
        industry: '',
        advantage: '',
        classify: ''

      },
      rules: {
        eName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          { validator: eName, trigger: 'blur' },
          { max: 30, message: '请勿输入过长名称', trigger: ['blur', 'change'] }
        ],
        eCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          { validator: eCode, trigger: 'blur' },
          { min: 18, max: 18, message: '请输入正确组织机构代码', trigger: ['blur', 'change'] }
        ],
        jperson: [
          { required: true, message: '请输入法定代表人', trigger: 'blur' },
          { validator: jperson, trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: tel, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { validator: email, trigger: 'blur' }
        ],

        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { validator: contacts, trigger: 'blur' }

        ],
        eAddr: [
          { required: true, message: '请输入注册地址', trigger: 'blur' },
          { validator: eAddr, trigger: 'blur' }
        ],
        enterprise: [
          { required: true, message: '请输入企业英文名', trigger: 'blur' },
          { validator: enterprise, trigger: 'blur' }
        ],
        website: [
          { required: true, message: '请输入企业网址', trigger: 'blur' },
          { validator: website, trigger: 'blur' }
        ],
        introduce: [
          { required: true, message: '请输入企业介绍', trigger: 'blur' },
          { validator: introduce, trigger: 'blur' }
        ],
        foundtime: [
          { required: true, message: '请输入成立时间', trigger: 'blur' },
          { validator: foundtime, trigger: 'blur' }

        ],
        staff: [
          { required: true, message: '请输入目前员工数', trigger: 'blur' },
          { validator: staff, trigger: 'blur' }
        ],
        industry: [
          { required: true, message: '请输入所属行业', trigger: 'blur' },
          { validator: industry, trigger: 'blur' }
        ],
        advantage: [
          { required: true, message: '请输入企业优势', trigger: 'blur' },
          { validator: advantage, trigger: 'blur' }
        ],
        classify: [
          { required: true, message: '请输入企业所有制', trigger: 'blur' },
          { validator: Classify, trigger: 'blur' }
        ]

      }
    }
  },
  created () {
    var that = this
    /* 获取父页面参数 */

    /* 后台申请默认值 */
    dataGetUrl(rootPathssb.rootPath + '/user/find').then(function (response) {
      that.checkSignin(response.data.result)
      console.log(response.data)
      if (response.data.result === 1) {
        console.log('cg')
        that.form1 = response.data.object
      };

      console.log(response.data)
    }).catch(function (error) {
      console.log(error); console.log('aaa')
    })
  },
  methods: {
    submitForm (event) {
      var params = new URLSearchParams()
      let that = this
      params.append('eCode', this.form1.eCode)
      params.append('jperson', this.form1.jperson)
      params.append('tel', this.form1.tel)
      params.append('contacts', this.form1.contacts)
      params.append('eAddr', this.form1.eAddr)
      params.append('eName', this.form1.eName)
      params.append('enterprise', this.form1.enterprise)
      params.append('website', this.form1.website)
      params.append('email', this.form1.email)
      params.append('introduce', this.form1.introduce)
      params.append('foundtime', this.form1.foundtime)
      params.append('staff', this.form1.staff)
      params.append('industry', this.form1.industry)
      params.append('advantage', this.form1.advantage)
      params.append('classify', this.form1.classify)
      dataPost(rootPathssb.rootPath + '/user/app/add', params).then(function (response) {
        that.checkSignin(response.data.result)
        if (response.data.result === 1) {
          console.log('cg')
          alert('保存成功')
          that.$router.push({path: '/enterpriselist'})
        };

        console.log(response.data)
      }).catch(function (error) {
        console.log(error); console.log(2222222222)
      })
    },
    checkForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.submitForm()
          console.log('成功!')
        } else {
          console.log('提交失败')
          return false
        }
      })
    },
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    }
  }
}
</script>

<style >
.body1{
  width:600px;
  margin: 0 auto;
}
.body1 .el-form-item__label{
  width: 140px !important;
}
.body1 .el-form-item__content{
   margin-left: 140px !important;
 }
</style>



// WEBPACK FOOTER //
// src/components/enterprise/enterevaluation.vue